export const insureRoute = [
  {
    path: '/url',
    name: 'url',
    meta: { title: 'url' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/url.vue'
      ),
  },
  {
    path: '/insure_home_dev',
    name: 'insure_home_dev',
    meta: { title: '跳转页' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/home.vue'
      ),
  },
  {
    path: '/insure_home',
    name: 'insure_home',
    meta: { title: '跳转页' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/home.vue'
      ),
  },
  // 保险授权
  {
    path: '/insure_auth_dev',
    name: 'insure_auth_dev',
    meta: { title: '加载中...' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/auth.vue'
      ),
  },
  {
    path: '/insure_auth',
    name: 'insure_auth',
    meta: { title: '加载中...' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/auth.vue'
      ),
  },

  // 保险登录
  {
    path: '/insure_login',
    name: 'insure_login',
    meta: { title: '登录/注册' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/login.vue'
      ),
  },

  // 选择店铺
  {
    path: '/insure_changeStore',
    name: 'insure_changeStore',
    meta: { title: '店铺选择' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/store_change.vue'
      ),
  },

  // 第三方页面
  {
    path: '/insure_linkPage',
    name: 'insure_linkPage',
    meta: { title: '加载中...' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/link_page.vue'
      ),
  },

  // 商户保险
  {
    path: '/insure_main',
    name: 'insure_main',
    meta: { title: '商户保险' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/insure_main.vue'
      ),
  },

  // 上传已够保单
  {
    path: '/insure_edit',
    name: 'insure_edit',
    meta: { title: '上传已购保单' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/insure_edit.vue'
      ),
  },

  // 保单详情
  {
    path: '/insure_detail',
    name: 'insure_detail',
    meta: { title: '保单详情' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/insure_detail.vue'
      ),
  },

  // 保险分享
  {
    path: '/insure_share_dev',
    name: 'insure_share_dev',
    meta: { title: '立即分享', keepAlive: true },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/share.vue'
      ),
  },
  {
    path: '/insure_share',
    name: 'insure_share',
    meta: { title: '立即分享', keepAlive: true },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/share.vue'
      ),
  },


  // 分享记录
  {
    path: '/share_detail',
    name: 'share_detail',
    meta: { title: '分享记录' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-business/share_detail.vue'
      ),
  },

  // 跳转浏览器引导页
  {
    path: '/guide_page',
    name: 'guide_page',
    meta: { title: '跳转' },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../components/GuidePage.vue'
      ),
  },
  {
    path: '/insure_n_index',
    name: 'insure_n_index',
    meta: {
      title: '身份选择',
      isShowOrHiddenNavBar: 0
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/Insure-noWD/index.vue'
      ),
  }
];
